import { useEffect, useState } from "react";
import ApiCall from "../api";

const useCatalogos = (nombreCatalogo) => {
  const [data, setData] = useState([]);
  useEffect(() => {
    const getCatalogo = async () => {
      try {
        const response = await ApiCall({
          url: `Catalog/${nombreCatalogo}`,
          method: "GET",
          body: null,
        });
        response.json().then((e) => {
          setData(e);
        });
      } catch (error) {
        setData([]);
      }
    };
    getCatalogo();
    return () => {
      setData([]);
    };
  }, [nombreCatalogo]);
  return data;
};
export default useCatalogos;
